import { App } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

export const useNotification = () => {
  const { notification } = App.useApp();

  const openNotificationWithIcon = (
    type: 'success' | 'error',
    message: string,
  ) => {
    notification[type]({
      message: type === 'success' ? 'Success' : 'Error',
      description: message,
      duration: 3,
      icon:
        type === 'success' ? (
          <CheckCircleOutlined style={{ color: '#52c41a' }} />
        ) : (
          <CloseCircleOutlined style={{ color: '#ff4d4f' }} />
        ),
    });
  };

  return { openNotificationWithIcon };
};
